module.exports = __webpack_public_path__ + "static/section_top-307d230a5a8dda0c9677cf402ce714be.png";